import { IDType } from 'mobx-restful';

export default {
    welcome: '欢迎',
    upstream_projects: '上游项目',
    home_page: '主页',
    console: '控制台',
    source_code: '源代码',
    component: '组件',
    pagination: '分页',
    chart: '图表',
    downloader: '下载器',
    powered_by: '强力驱动自',
    documentation: '文档',
    learn: '学习',
    examples: '示例',
    deploy: '部署',

    // REST table
    create: '新增',
    submit: '提交',
    cancel: '取消',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    total_x_rows: ({ totalCount }: { totalCount: number }) =>
        `共 ${totalCount} 行`,
    sure_to_delete_x: ({ keys }: { keys: IDType[] }) =>
        `您确定删除 ${keys.join('、')} 吗？`,
    repository_name: '仓库名',
    programming_language: '编程语言',
    topic: '话题',
    star_count: '星标数',

    // Scroll List
    scroll_list: '滚动列表',
    load_more: '加载更多……',
    no_more: '没有更多',

    // Login
    user_login: '用户登录',
    enter_login_info: '请输入您的登录凭据',
    username: '用户名',
    enter_username: '请输入用户名',
    password: '密码',
    enter_password: '请输入密码',
    remember_login: '记住登录状态',
    login_now: '立即登录',
    ai_work_order: 'AI单王',
    work_order_ai_assistant: '营服工单AI智能助手',
    system_normal: '系统正常',
    network_normal: '网络连接正常',
    copyright_info: '© 2025 AI单王 版本 1.0.0',

    // Category page
    category_system: '分类体系管理',
    ai_auto_classify: 'AI 自动分类',
    new_category: '新增分类',
    business_type: '业务类型',
    level1_category: '一级类别',
    level2_category: '二级类别',
    level3_category: '三级类别',
    level3_detail: '三级类别细分项',
    remark: '备注',
    order_count: '工单数量',
    department: '部门',
    specialist_office: '专业处室',
    sort_order: '排序',
    search_category: '搜索分类...',
    enter_text: '请输入',
    enter_sort_hint: '请输入排序，数字小的排在最前面',
    confirm: '确定',
    ai_classifying: '光明电力大模型 - 自动分类进行中',
    analyzing_data:
        '正在分析历史工单数据，识别新的工单类别和模式。这个过程可能需要几分钟时间，请耐心等待。',
    analyzing_orders: '正在分析工单数据',
    new_category_suggestions: '发现新的分类建议',
    last_update_time: '上次更新时间',
    reject: '拒绝',
    accept: '采纳',
    close: '关闭',
    confirm_update: '确认更新',
    matching_orders: '匹配工单数：',
    confidence: '置信度：',
    new_category_tag: '新类别',

    // Work Order Management
    work_order_management: '工单管理',
    order_id: 'ID号',
    order_number: '工单编号',
    order_type: '工单属性',
    category: '分类属性',
    acceptance_time: '受理时间',
    acceptance_content: '受理内容',
    processing_status: '处理情况',
    processing_result: '处理结果',
    satisfaction_level: 'AI化优化',
    ai_optimization_reason: '分类优化',
    upload_time: '上传时间',
    operation: '操作',
    normal_order: '查看工单',
    duplicate_order: '重复工单',
    sensitive_order: '敏感工单',
    responsible_order: '有责工单',
    satisfied: '满意',
    basic: '基本满意',
    unsatisfied: '不满意',
    time_period: '工单时间段',
    search_order_number: '请输入工单编号进行搜索',
    category_filter: '请选择分类',
    screening: '筛选',
    internal_search: '内容搜索',
    search_keywords: '请输入关键字搜索受理内容、处理情况',

    // Classification Task Management
    classification_task_list: '工单分类优化任务列表',
    classification_task_management: '分类优化任务管理',
    task_id: '任务ID',
    task_name: '任务名称',
    ai_capabilities: 'AI能力',
    task_status: '任务状态',
    total_work_orders: '工单总数',
    processed_work_orders: '已处理工单',
    started_at: '开始时间',
    ended_at: '结束时间',
    created_at: '创建时间',
    updated_at: '更新时间',
    completed_at: '完成时间',
    actions: '操作',
    view_details: '查看详情',
    create_task: '新增任务',
    edit_task: '编辑任务',
    task_details: '任务详情',
    category_information: '分类信息',
    remarks: '备注',
    task_pending: '待处理',
    task_in_progress: '进行中',
    task_completed: '已完成',
    task_rejected: '已拒绝',
    enter_task_name: '请输入任务名称',
    enter_work_order_number: '请输入工单编号',
    enter_original_category: '请输入原分类',
    enter_suggested_category: '请输入建议分类',
    enter_optimization_reason: '请输入优化理由',
    enter_assignee: '请输入分配人',
    enter_remarks: '请输入备注',
    saving: '保存中...',
    update: '更新',
    back_to_list: '返回列表',
    confirm_delete_task: '确定要删除这个任务吗？',
    task_not_found: '任务未找到',
    loading: '加载中...',

    // Document Knowledge Base
    document_knowledge_base: '文档知识库',
    document_list: '文档列表',
    upload_document: '上传文档',
    document_name: '文档名称',
    file_type: '文件类型',
    file_size: '文件大小',
    status: '状态',
    processing: '处理中',
    completed: '已完成',
    failed: '失败',
    select_files: '选择文件',
    drag_files_here: '拖拽文件到此处',
    or: '或',
    click_to_select: '点击选择文件',
    selected_files: '已选择文件',
    file_info: '文件信息',
    description: '描述',
    please_input: '请输入',
    next_step: '下一步',
    previous_step: '上一步',

    // Dashboard
    welcome_back: '欢迎回来',
    all_branches: '全部分公司',
    all_power_stations: '全部供电所',
    total_orders: '工单总数',
    basic_orders: '基础工单',
    sensitive_orders: '敏感工单',
    responsible_orders: '有责工单',
    generated_supervision: '已生成督办单',
    resolved_orders: '已化解工单数',
    order_data_7days: '工单数据（近7日）',
    new_orders: '新增工单',
    duplicate_orders: '重复工单',
    business_type_distribution: '工单业务类型占比（全部）',
    problem_category_distribution: '问题工单类别占比（全部）',
    current_tasks: '当前任务',
    work_order_classification: '工单分类',
    view_more: '查看更多',
    rank: '排名',
    task_serial_number: '序号',
    current_status: '当前状态',
    abnormal: '异常',

    // Document Upload Steps
    upload_text_file: '上传文本文件',
    drag_or_select: '拖拽文件或文件夹至此，或者',
    select_file: '选择文件',
    supported_formats: '已支持',
    max_files_hint: '每批最多',
    files_unit: '个文件',
    max_size_hint: '每个文件不超过',
    file_exceeds_limit: ({ name }: { name: string }) =>
        `文件 ${name} 超过 512 MB 限制`,
    preview: '预览',
    chunks_unit: '个块',
    document_uploaded: '文档已上传',
    upload_to_kb_hint:
        '文档已上传至知识库：供电方案-案例，你可以在知识库的文档列表中找到它。',
    embedding_processing: '嵌入处理中...',
    chunking_mode: '分段模式',
    custom: '自定义',
    max_chunk_length: '最大分段长度',
    text_preprocessing: '文本预处理规则',
    replace_whitespace: '替换掉连续的空格、换行符和制表符',
    index_method: '索引方式',
    high_quality: '高质量',
    retrieval_settings: '检索设置',
    hybrid_search: '混合检索',
    complete: '完成',
    select_data_source: '选择数据源',
    text_chunking_cleaning: '文本分段与清洗',
    process_complete: '处理并完成',

    // Deduplication Task Pages
    create_extraction_task: '创建提取任务',
    duplicate_work_order_extraction: '重复工单智能提取',
    deduplication_task_list: '重复工单任务列表',
    rule_knowledge_base: '规则知识库',
    task_time: '任务时间',
    enter_task_name_search: '请输入任务名称进行搜索',
    search: '搜索',
    all: '全部',
    in_progress: '进行中',
    deduplication_result: '重复工单分析结果',
    deduplication_task_detail: '重复工单任务详情',
    task_steps: '任务步骤',
    real_time_logs: '实时日志',
    data_preprocessing: '数据预处理',
    reading_classification_workorders: ({ task }: { task: number }) =>
        `读取工单分类任务第 ${task} 个工单`,
    analyzing_workorders: '正在分析工单',

    // Optimization Task Creator
    create_optimization_task: '创建优化任务',
    upload_work_order_file: '上传工单文件',
    historical_data: '历史数据',
    support_excel_format: '支持 Excel 格式文件',
    max_size_10mb: '最大 10MB',
    or_drag_file_here: '或拖拽文件至此',
    uploading: '正在上传',
    format_validation: '文件格式校对',
    file_format_not_correct: '文件格式不正确',
    error_label: '错误',
    column_missing: '列缺失',
    wrong_file_type: '文件类型错误',
    word_vs_expected_format: '字段与预期格式',
    check_file_not_correct: '检查文件不正确',
    work_order_count: '工单数量',
    uploaded_orders: '已上传工单',
    orders_excluded: '已排除/总工单',
    reselect_file: '重新选择文件',
    ai_analysis_capabilities: 'AI 分析功能',
    work_order_classification_optimization: '工单分类智能优化',
    create_sensitive_task: '新增敏感任务',
    create_responsible_task: '新增有责任务',
    report_analysis_center: '报表分析中心',
    report_template_management: '报表模板管理',
    report_template_library: '报表模板库',
    weekly_report_template: '周报模板',
    monthly_report_template: '月报模板',
    quarterly_report_template: '季报模板',
    weekly_report_description: '供电服务重点问题通报',
    monthly_report_description: '优质服务运营周报',
    quarterly_report_description: '供电服务重点问题通报',
    chars_unit: '字符',
    related_data_unit: '关联数据',
    auto_identify_work_orders: '自动识别工单类别，提升分类效率',
    identify_duplicate_records: '识别重复工单记录，避免重复处理',
    sensitive_work_order_extraction: '敏感工单智能提取',
    auto_detect_sensitive_data: '自动检测敏感信息，加强数据安全',
    employee_work_order_audit: '有员工工单审计',
    analyze_employee_handling: '分析员工工单处理情况，提升管理效率',
    start_now: '立即上线',
    file_exceeds_max_size: ({ size }: { size: string }) =>
        `文件超过最大限制 ${size}`,
    original_category: '原分类',
    change_reason: '变更原因',
    duplicate_workorder_analysis: '重复工单分析',
    duplicate_workorder_found: ({ count }: { count: number }) =>
        `发现 ${count} 个重复工单`,
    in_analysis: '分析中',
    analysis_progress: ({
        percent,
        count
    }: Record<'percent' | 'count', number>) =>
        `分析进度：${percent}%，发现 ${count} 个重复工单`,
    id_number: 'ID号',
    work_order_id: '工单编号',
    duplicate_type: '重复类型',
    classification_result: '分类结果',
    corresponding_workorder: '对应工单号',
    reason_for_duplication: '重复原因',
    processing_time: '处理时间',
    details: '详情',
    pending: '待处理',
    processed: '已处理',
    no_change: '无需变更',
    manual_review: '人工审核',
    similarity: '相似度',

    // Sensitive and Responsible work order fields
    sensitive_type: '敏感类型',
    ai_extraction_reason: 'AI提取原因',
    unit_name: '单位名称',
    power_supply_office: '供电所',
    area_manager: '片区经理',
    violation_issue: '违章问题',
    rectification_requirement: '整改要求',
    referenced_policy: '引用依据',

    // Additional task page translations
    start_time: '开始时间',
    current_stage: '当前阶段',
    estimated_remaining: '预计剩余',
    please_select_classification_result: '请先选择工单分类结果',
    select_classification_task_hint:
        '（请选择分类任务后，开始对指定分类任务下的工单进行',
    analysis_suffix: '分析）',
    estimated_analysis_time_15_30: '预计分析耗时：15~30分钟',
    start_analysis_button: '开始分析',
    export_file: '导出文件',

    // Supervision Order Management
    supervision_order_management: '督办工单智能提取',
    supervision_order_list: '督办单列表',
    supervision_order_intelligent_generation: '督办单智能生成',
    create_supervision_task: '创建提取任务',
    supervision_task_list: '督办工单任务列表',
    pending_supervision_orders: '待督办工单',
    supervision_status: '督办状态',
    supervision_type: '督办类型',
    problem_description: '问题描述',
    create_supervision_order: '生成督办单',
    new_supervision_order: '新建督办单',
    work_order_original_info: '工单原始信息',
    primary_category: '一级类型',
    secondary_category: '二级类型',
    tertiary_category: '三级类型',
    order_completion_time: '工单下发时间',
    return_timestamp: '归档时间',
    processing_situation: '处理情况',
    problem_extraction_info: '问题提取信息',
    problem_category: '问题类型',
    warning_level: '预警等级',
    red_warning: '红色预警',
    trigger_keywords: '触发关键词',
    trigger_count: '触发次数',
    supervision_order_creation_info: '督办单生成信息',
    supervisor: '督办人',
    responsible_department: '责任部门',
    receiver: '接收人',
    supervision_template: '督办单模板',
    supervision_template_1: '督办单模版1',
    confirm_create: '确定生成',
    all_statuses: '全部',
    pending_supervision: '待督办',
    supervising: '督办中',
    supervision_completed: '已督办',
    order_time: '工单时间',
    select_date: '年/月/日',
    filter: '筛选',
    export_all: '全部',
    duplicate_discovery: '重复致电',
    cancelled_orders: '敏感工单',
    listed_orders: '违规工单',
    complaint: '投诉',
    poor_attitude: '态度不好',

    // Sensitive Rule List Page
    sensitive_rule_list: '敏感工单智能提取',
    add_rule: '添加规则',
    batch_delete: '批量删除',
    vocabulary_name: '词汇名称',
    vocabulary_description: '词汇描述',
    rule_type: '规则类型',
    triggered_work_order_count: '触发工单数',
    work_order_chain: '工单链',
    keyword_semantic: '关键词语义',
    level_1_warning: '一级预警',
    level_2_warning: '二级预警',
    level_3_warning: '三级预警',
    search_classification: '搜索分类...',
    sensitive_task_list: '敏感工单任务列表',
    responsible_task_list: '有责工单任务列表',
    create_audit_task: '创建审查任务',

    // Responsible Rule List Page
    responsible_rule_list: '有责工单智能审查',
    rule_name: '规则名称',
    rule_description: '规则描述',
    associated_documents: '关联知识库文档',

    // Report List Page
    report_management: '报表管理',
    report_list: '报表任务列表',
    create_report_task: '新建报表分析任务',
    report_name: '任务名称',
    report_type: '报表类型',
    analysis_range: '分析范围',
    report_status: '状态',
    report_in_progress: '进行中',
    report_queued: '排队中',
    report_completed: '已完成',
    report_failed: '失败',
    report_type_weekly: '周报',
    report_type_monthly: '月报',
    report_type_quarterly: '季报',
    report_type_yearly: '年报',
    download: '下载',
    time_range: '时间范围',
    select_template: '选择模板',
    quality_service_weekly: '优质服务运营周报',
    power_service_issues: '供电服务重点问题通报',
    annual_summary: '全年总结',
    all_business_control: '全业务管控',
    quality_service: '优质服务',
    ai_suggestion: 'AI 智能建议',
    based_on_history: '基于历史数据分析，AI 建议关注以下异常指标：',
    duplicate_rate_increase: '重复工单率较上月上升 15%，建议分析根因',
    night_failure_low: '夜间故障处理时效低 8%，建议优化值班安排',
    time_range_has_orders: '该时间范围有 2342 个工单，预计分析耗时：3~5分钟',
    start_analysis: '开始分析',
    monthly_total_orders: '本月工单总量',
    pending_orders: '待处理工单',
    processing_timeliness: '处理及时率',
    abnormal_orders: '异常工单数',
    compare_last_month: '较上月'
} as const;
